import type { DublicatesFilters } from '@pages/DublicateClients/types';

export const PF = 'dublicate-clients';

export const initialFilters: DublicatesFilters = {
  SearchTerm: null,
  statusesIds: null,
  ItemsPerPage: 20,
  PageN: 1,
  Total: 0,
};
